import script from "./PatientOrganismList.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientOrganismList.vue?vue&type=script&setup=true&lang=js"

import "./PatientOrganismList.vue?vue&type=style&index=0&id=05370a84&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05370a84"]])

export default __exports__